"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamToName = exports.TeamToColor = exports.ColorToTeam = void 0;
const ETeam_1 = require("../dto/ETeam");
function ColorToTeam(color) {
    switch (color) {
        case "red":
            return ETeam_1.ETeam.RED;
        case "blue":
            return ETeam_1.ETeam.BLUE;
        case "yellow":
            return ETeam_1.ETeam.YELLOW;
        case "green":
            return ETeam_1.ETeam.GREEN;
        default:
            return ETeam_1.ETeam.NONE;
    }
}
exports.ColorToTeam = ColorToTeam;
function TeamToColor(team) {
    switch (team) {
        case ETeam_1.ETeam.RED:
            return "rgba(221, 40, 16, 1)";
        case ETeam_1.ETeam.BLUE:
            return "rgba(16, 110, 221, 1)";
        case ETeam_1.ETeam.YELLOW:
            return "rgba(255, 213, 63, 1)";
        case ETeam_1.ETeam.GREEN:
            return "rgba(36, 189, 79, 1)";
        default:
            return "none";
    }
}
exports.TeamToColor = TeamToColor;
function TeamToName(team) {
    switch (team) {
        case ETeam_1.ETeam.RED:
            return "rouge";
        case ETeam_1.ETeam.BLUE:
            return "bleue";
        case ETeam_1.ETeam.YELLOW:
            return "jaune";
        case ETeam_1.ETeam.GREEN:
            return "verte";
        default:
            return "none";
    }
}
exports.TeamToName = TeamToName;
